import { render, staticRenderFns } from "./TemplatesFilters.vue?vue&type=template&id=67f077ea&scoped=true"
import script from "./TemplatesFilters.vue?vue&type=script&lang=js"
export * from "./TemplatesFilters.vue?vue&type=script&lang=js"
import style0 from "./TemplatesFilters.vue?vue&type=style&index=0&id=67f077ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f077ea",
  null
  
)

export default component.exports